import {
    GAME_ITEM_ADDED_PREFIX,
    GAME_ITEM_CANCELED_PREFIX,
} from '@bg-shared/constants/socketChannels';
import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { GameId } from '@bg-shared/enums/GameId';
import { ICardGameRunItemCanceled, IGameRunItem, IGameRunItemsList } from './interfaces';

class CurrentResultService {
    public get(gameId: GameId, runCode: string): Promise<IGameRunItemsList> {
        return new Promise((resolve) => {
            webSocketsRepository.emitLast(`${GAME_ITEM_ADDED_PREFIX}${gameId}:${runCode}`, resolve);
        });
    }

    public subscribe(gameId: GameId, listener: (data: IGameRunItem) => void): () => void {
        return webSocketsRepository.on<IGameRunItem>(
            `${GAME_ITEM_ADDED_PREFIX}${gameId}`,
            (data) => {
                listener(data);
            },
        );
    }

    public subscribeCanceled(
        gameId: GameId,
        listener: (data: ICardGameRunItemCanceled) => void,
    ): () => void {
        return webSocketsRepository.on<ICardGameRunItemCanceled>(
            `${GAME_ITEM_CANCELED_PREFIX}${gameId}`,
            (data) => {
                listener(data);
            },
        );
    }
}

export const currentResultService = new CurrentResultService();
